import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from 'src/app/services/loginService';
import { AlertaService } from '@services/alerta/alerta.service';

@Injectable()
export class AuthGuard  {
  constructor(
    private router: Router,
    private _loginService: LoginService,
    private alerta: AlertaService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    let token = localStorage.getItem('id_token');

    // Verificar si el token existe y no ha expirado
    if (token && !this.tokenExpired(token)) {
      // Si tenemos token válido, verificar identity
      const identity = this._loginService.getIdentity();

      if (identity) {
        // Token e identity válidos
        return this._loginService.checkLogin(this.router);
      } else {
        // Token válido pero no hay identity - permitir acceso y que la app maneje la recarga
        console.warn('Token válido pero identity no encontrado - permitiendo acceso');
        return true;
      }
    }

    // Token inválido o no existe
    this.alerta.openSnackAlert('La sesion ha caducado, es necesario iniciar sesion de nuevo','Error');
    this.router.navigate(['/sso/login']);
    return false;
  }

  private tokenExpired(token: string) {
    const expiry = JSON.parse(atob(token.split('.')[1])).exp;
    return Math.floor(new Date().getTime() / 1000) >= expiry;
  }
}
